import i18n from "@/i18n.js";
export const statusFormat = (value) => {
  switch (value) {
    case "on_hold":
      return i18n.t("analytic.ab.onHold");
    case "running":
      return i18n.t("analytic.ab.running");
    case "completed":
      return i18n.t("analytic.ab.completed");
    default:
      return "";
  }
};
const getters = {
  attachFormatted(state) {
    const { attach } = state;
    // TODO: need to fix attach
    if (attach) {
      let status = statusFormat(attach.status);
      return {
        ...attach,
        created_at: attach.created_at,
        statusText: status
      };
    }

    return null;
  },

  categoriedCampaigns(state) {
    const campaigns = state.campaigns.list;
    let list = {
      all: campaigns.map(campaign => {
        let item = {
          ...campaign
        }
        return item;
      }),
      on_hold: campaigns.filter(campaign => {
        return campaign.status == "on_hold";
      }),
      running: campaigns.filter(campaign => {
        return campaign.status == "running";
      }),
      completed: campaigns.filter(campaign => {
        return campaign.status == "completed";
      }),
    };

    return list;
  }
};

export default getters;
